export function mergeNoteSummary(existing: string | null | undefined, summary: string): string {
  const current = existing?.trim() ?? "";
  const next = summary.trim();
  if (!next) return current;
  if (!current) return next;
  return `${current}\n\n${next}`;
}
